import React from "react";

export default function Ideas() {
  return <div>Ideas</div>;
}
